import { Text, Select, Button, Spinner, Heading } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import crearReservacion from '../../services/crearReservacion';
import createBooking from '../../services/createBooking';
import "./confirmacion.css"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import UserContext from '../../context/userContext';
import { transformCabana } from '../../helpers/transformCabana';
import { verificarNoches } from '../../services/verificarNoches';
import CalendarioContext from '../../context/calendarioContext';
import { formatToMXN } from '../util/util';
import { useTranslation } from 'react-i18next';

const Confirmacion = ({
  room,
  date,
  data,
  id,
  noches,
  isDayPass,
  offer,
  isCuentaPropia,
  setIsDisabled,
}) => {

  const { t } = useTranslation();

  const [numeroPersonas, setNumeroPersonas] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({ error: false, msg: '' });
  const [nombreDayPass, setNombreDayPass] = useState('');
  const [nombreCuentaPropia, setNombreCuentaPropia] = useState('');
  const { user, setUser, otraCabana } = useContext(UserContext);
  const { people } = useContext(CalendarioContext);

  const occupancy = [];
  for (let i = 1; i <= room.max_occupancy; i++) {
    occupancy.push(i);
  }

  // const onChange = (e) => {
  //   if (e.target.value) {
  //     setNumeroPersonas(e.target.value);
  //   } else {
  //     setNumeroPersonas(null);
  //   }
  // };

  const descuento = (precio) => {
    return isDayPass
      ? precio * 0.1
      : otraCabana && transformCabana(user.tipoCabana) !== room.short_name
      ? precio * 0.2
      : null;
  };
  const handleBooking = async () => {
    setIsLoading(true);
    setIsDisabled(true);
    const dataConPersonas = { ...data };
    dataConPersonas.rooms[0]['max_adults'] = numeroPersonas;
    if (!otraCabana) {
      const {
        data: { nochesDisponibles },
      } = await verificarNoches(id, noches, (new Date(dataConPersonas["date_from"])).toISOString(), (new Date(dataConPersonas["date_to"])).toISOString());
      if (!nochesDisponibles) {
        setError({ error: true, msg: 'No hay noches disponibles' });
        setIsLoading(false);
        setIsDisabled(false);
        return;
      }
    }
  
  try{
    const response = await crearReservacion({
      //fechaLlegada: res.data.date_arrival + 'T00:00:00.000Z',
      //fechaSalida: res.data.date_departure + 'T00:00:00.000Z',
      dataReservatio: dataConPersonas,
      tipoReservacion: isDayPass
        ? 'CORTESIA'
        : isCuentaPropia
        ? 'CUENTAPROPIA'
        : otraCabana
        ? 'OTRACABANA'
        : 'TITULAR',
      nombreQuienReserva: isDayPass
        ? nombreDayPass
        : isCuentaPropia
        ? nombreCuentaPropia
        : data.customer.first_name,
      nombreTitular: `${data.customer.first_name} ${data.customer.last_name}`,
      tipoCabana: room.name,
      titularId: id,
      adminId: null,
      //token: res.data.token,
      numeroPersonas,
      noches,
      precioTotal: offer.total_price,
      descuento: descuento(+offer.total_price),
      isAdicionales: otraCabana,
    })
    if (response.status === 200) {
      const foto = user.foto;
      setUser({ ...response.data.titularActualizado, foto });
      onOpen();
    } else {
      setError({
        error: true,
        msg: 'No se logró crear la reservación en la base de datos',
      });
      onOpen();
    }
  } catch (err) {
    setError({ error: true, msg: err && err.error ? err.error : "Error al crear la reservación" });
    onOpen();
  }
  finally {
    setIsLoading(false);
  }
  
    // .then((res) => {
    //   if (res.status === 200) {
    //     const foto = user.foto;
    //     setUser({ ...res.data.titularActualizado, foto });
    //     onOpen();
    //   } else {
    //     setError({
    //       error: true,
    //       msg: 'No se logró crear la reservación en la base de datos',
    //     });
    //   }
    // })
    // .catch((err) => {
    //   console.log("///////////////////ERROR/reservar//////////////////", err)
    //   setError({ error: true, msg: err.error });
    //   onOpen();
    // }).finally(() => {
    //   setIsLoading(false);
    // });
  //   createBooking(dataConPersonas)
  //     .then((res) => {
  //       crearReservacion({
  //         //fechaLlegada: res.data.date_arrival + 'T00:00:00.000Z',
  //         //fechaSalida: res.data.date_departure + 'T00:00:00.000Z',
  //         tipoReservacion: isDayPass
  //           ? 'CORTESIA'
  //           : isCuentaPropia
  //           ? 'CUENTAPROPIA'
  //           : otraCabana
  //           ? 'OTRACABANA'
  //           : 'TITULAR',
  //         nombreQuienReserva: isDayPass
  //           ? nombreDayPass
  //           : isCuentaPropia
  //           ? nombreCuentaPropia
  //           : data.customer.first_name,
  //         nombreTitular: `${data.customer.first_name} ${data.customer.last_name}`,
  //         tipoCabana: room.name,
  //         titularId: id,
  //         adminId: null,
  //         //token: res.data.token,
  //         numeroPersonas,
  //         noches,
  //         precioTotal: offer.total_price,
  //         descuento: descuento(+offer.total_price),
  //         isAdicionales: otraCabana,
  //       })
  //         .then((res) => {
  //           if (res.status === 200) {
  //             const foto = user.foto;
  //             setUser({ ...res.data.titularActualizado, foto });
  //             onOpen();
  //           } else {
  //             setError({
  //               error: true,
  //               msg: 'No se logró crear la reservación en la base de datos',
  //             });
  //           }
  //         })
  //         .catch((err) => {
  //           setError({ error: true, msg: err });
  //           onOpen();
  //         }).finally(() => {
  //           setIsLoading(false);
  //         });
  //     })
  //     .catch((err) => {
  //       setError({ error: true, msg: err });
  //       setIsLoading(false);
  //     })
  };

  useEffect(() => {
    console.log("///////////////////ERROR///////////////////", error)
  }, [error])

  useEffect(() => {
    if (people != '') {
      setNumeroPersonas(people);
    }
  }, [people]);


  return (
    <>
      {/* ----------------------------------------------------------------------------
          ROOT: ancho 100 % en móviles, 50 % en ≥ lg y centrado
      ----------------------------------------------------------------------------- */}
      <div className="confirm-wrapper">
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Reservación exitosa</ModalHeader>
            <ModalBody>
              {error.error ? (
                <div>Ocurrió un error: {error.msg}</div>
              ) : (
                <div className="py-3">
                  <Button
                    onClick={() => navigate('/reservar-ahora')}
                    me="3"
                    colorScheme="blue"
                  >
                    Ir a formulario
                  </Button>
                  <Button
                    onClick={() => navigate('/reservaciones')}
                    colorScheme="orange"
                  >
                    Ir a mis reservaciones
                  </Button>
                </div>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
  
        <Text as="b" fontSize="xl">
          Confirmar
        </Text>
  
        <Text>
          Estoy de acuerdo con la reservación de la cabaña modelo{' '}
          <strong>{room.name}</strong> para las fechas:
        </Text>
        <Text as="b">del:</Text>
        <Text>{date.startStr}</Text>
        <Text as="b">al:</Text>
        <Text>{date.endStr}</Text>
  
        {isDayPass && (
          <div>
            A nombre de:
            <input
              className="form-control w-75"
              required
              value={nombreDayPass}
              onChange={(e) => setNombreDayPass(e.target.value)}
              disabled={isLoading}
            />
          </div>
        )}
  
        {isCuentaPropia && (
          <div>
            A nombre de:
            <input
              className="form-control w-75"
              required
              value={nombreCuentaPropia}
              onChange={(e) => setNombreCuentaPropia(e.target.value)}
              disabled={isLoading}
            />
          </div>
        )}
  
        {/* -------------------------------------------------------------------
             INFO DE PRECIO – ocupa 100 % en XS, 50 % en ≥ md
        -------------------------------------------------------------------- */}
        <div className="my-2 w-100 w-md-50">
          <Text>
            {t('FOR_PEOPLE')} <Text as="b">{people}</Text> {t('PEOPLE')}
          </Text>
          <Text as="b">{t('TOTAL_PRICE')}</Text>
          <Text>
            {formatToMXN(offer.total_price)}{' '}
            <Text fontWeight="bold">{t('PRICE_BEFORE_TAXES')}</Text>
          </Text>
  
          <Text fontWeight="bold" fontSize="22" mt="20px">
            {t('ACCEPT_HOTEL_POLICIES')}
          </Text>
        </div>
  
        <div className="d-flex justify-content-end">
          {isLoading && <Spinner size="lg" />}
          <Button
            colorScheme="orange"
            sx={{ opacity: people ? 1 : 0.5 }}
            mt="4"
            p="6"
            isDisabled={!people || isLoading}
            isLoading={isLoading}
            loadingText={t('RESERVING')}
            onClick={handleBooking}
          >
            {t('RESERVE')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default Confirmacion;
